const CanalIntegrated = ({language , token}) => {
    const newCanalIframe = "https:" +
    window.process.env.URL_Classement + "/channels"
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_canal_display"
        src={newCanalIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default CanalIntegrated